
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2f9f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2f9f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

parcelRequire("dqDIK");

var $4wCtj = parcelRequire("4wCtj");

var $io3Hd = parcelRequire("io3Hd");

var $dJ98Z = parcelRequire("dJ98Z");

var $cAhzP = parcelRequire("cAhzP");
(0, $4wCtj.library).add((0, $cAhzP.faBars), (0, $dJ98Z.faCalendarXmark), (0, $cAhzP.faCloudArrowUp), (0, $cAhzP.faBoxArchive), (0, $cAhzP.faFlag), (0, $cAhzP.faBoltLightning), (0, $cAhzP.faTriangleExclamation), (0, $io3Hd.faFacebook), (0, $io3Hd.faInstagram), (0, $io3Hd.faLinkedin), (0, $io3Hd.faTwitter), (0, $io3Hd.faYoutube));
(0, $4wCtj.dom).watch();
document.querySelectorAll(".admonition").forEach((elem)=>{
    let icon = "";
    if (elem.classList.contains("note")) icon = "fa-flag";
    else if (elem.classList.contains("caution")) icon = "fa-bolt-lightning";
    else if (elem.classList.contains("danger")) icon = "fa-triangle-exclamation";
    const titleElem = elem.querySelector(".admonition-title");
    titleElem.insertAdjacentHTML("afterbegin", `<i class="fa-solid ${icon}"></i>`);
});
const $3b36caa29a305119$var$toc = document.getElementById("toc");
const $3b36caa29a305119$var$subheadings = document.querySelectorAll(".subheading");
if ($3b36caa29a305119$var$subheadings) {
    $3b36caa29a305119$var$toc.classList.add("col-2");
    const innerElem = document.createElement("div");
    innerElem.classList.add("toc-inner", "sticky-top");
    innerElem.insertAdjacentHTML("afterbegin", `<p class="toc-title">On this page</p>`);
    $3b36caa29a305119$var$subheadings.forEach((elem)=>{
        innerElem.insertAdjacentHTML("beforeend", `<a class="toc-link" href="#${elem.id}">${elem.textContent}</a>`);
    });
    $3b36caa29a305119$var$toc.appendChild(innerElem);
}
document.addEventListener("DOMContentLoaded", (e)=>{
    document.querySelectorAll(".advisory-content > table").forEach((table)=>{
        const wrapper = document.createElement("div");
        wrapper.classList.add("table-responsive");
        const parent = table.parentNode;
        parent.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
});


//# sourceMappingURL=carbon_black.8d5273b6.js.map
